import angular from 'angular';
import sendingStyledContainer from './sendingStyledContainer';

export default angular
  .module('components.sendingStyledContainer', [])
  .component('sendingStyledContainer', sendingStyledContainer).name;
